import { render, staticRenderFns } from "./GoogleSafeBrowsing.vue?vue&type=template&id=3237583c&"
import script from "./GoogleSafeBrowsing.vue?vue&type=script&lang=js&"
export * from "./GoogleSafeBrowsing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports